import React from "react";
import Navigation from "./Navigation";
import { NavLink } from "react-router-dom";

var bnr = require("./../../images/background/bg-map.png");

class Header2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = { logo: require("./../../images/logo-1.png") };
  }

  state = { isSearchActive: false, isQuoteActive: false };

  handleSearchToggle = () => {
    this.setState({ isSearchActive: !this.state.isSearchActive });
  };

  handleQuoteToggle = () => {
    this.setState({ isQuoteActive: !this.state.isQuoteActive });
  };

  componentDidMount() {
    const handleScroll = () => {
      const offset = window.scrollY;

      const stickyheader = document.querySelector(".sticky-header ");

      if (offset >= 100) {
        stickyheader.classList.add("is-fixed");
        stickyheader.classList.add("color-fill");
      } else {
        stickyheader.classList.remove("is-fixed");
        stickyheader.classList.remove("color-fill");
      }
    };

    window.addEventListener("scroll", handleScroll);

    window.updateTopMostParent = (logopath) => {
      this.setState({ logo: logopath });
    };
  }

  render() {
    const isSearchActive = this.state.isSearchActive;
    const isQuoteActive = this.state.isQuoteActive;

    return (
      <>
        <header className="site-header nav-wide nav-transparent mobile-sider-drawer-menu">
          {/* <div className="top-bar">
            <div className="container">
              <div className="d-flex justify-content-between text-white">
                <ul className="list-unstyled e-p-bx">
                  <li>
                    <span>
                      <i className="fa fa-envelope" />{" "}
                    </span>{" "}
                    contact@associationlavallee.com
                  </li>
                  <li>
                    <span>
                      {" "}
                      <i className="fa fa-phone" />{" "}
                    </span>
                    (+212) 0600 000 000
                  </li>
                </ul>
                <ul className="list-unstyled social-bx text-white d-flex flex-wrap align-content-center">
                  <li>
                    <a href="https://www.facebook.com" target="_blank">
                      <i className="fa fa-facebook" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com" target="_blank">
                      <i className="fa fa-instagram" />
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com" target="_blank">
                      <i className="fa fa-twitter" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com" target="_blank">
                      <i className="fa fa-youtube" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div> */}
          <div className="sticky-header main-bar-wraper navbar-expand-lg">
            <div className="main-bar">
              <div className="container clearfix">
                <div className="logo-header">
                  <div className="logo-header-inner logo-header-one">
                    <NavLink to={"./"}>
                      <img src={this.state.logo} alt="valley" />
                    </NavLink>
                  </div>
                </div>
                {/* NAV Toggle Button */}
                <button
                  id="mobile-side-drawer"
                  data-target=".header-nav"
                  data-toggle="collapse"
                  type="button"
                  className="navbar-toggler collapsed"
                >
                  <span className="sr-only">Toggle navigation</span>
                  <span className="icon-bar icon-bar-first" />
                  <span className="icon-bar icon-bar-two" />
                  <span className="icon-bar icon-bar-three" />{" "}
                </button>
                {/* EXTRA NAV */}
                <div className="extra-nav">
                  <div className="extra-cell">
                    <NavLink to={"#"} onClick={this.handleSearchToggle}>
                      <i className="fa fa-search mt-3 arrow-animation" />
                    </NavLink>
                  </div>
                  <div className="extra-cell profile-menu">
                    <nav className="">
                      <ul>
                        <li>
                          <img
                            src="https://i.stack.imgur.com/l60Hf.png"
                            className="profile"
                          />
                          <ul>
                            <li className="sub-item">
                              <a href={"/account"}>
                                <span className="material-icons-outlined">
                                  <i className="fa fa-user-o" />
                                </span>
                                <p>Mon Compte</p>
                              </a>
                            </li>
                            <li className="sub-item">
                              <a>
                                <span className="material-icons-outlined">
                                  <i className="fa fa-commenting-o" />
                                </span>
                                <p>Chat</p>
                              </a>
                            </li>
                            <li className="sub-item">
                              <a href={"/account/annonces"}>
                                <span className="material-icons-outlined">
                                  <i className="fa fa-newspaper-o" />
                                </span>
                                <p>Mes Actualités</p>
                              </a>
                            </li>
                            <li className="sub-item">
                              <a href={"/projets"}>
                                <span className="material-icons-outlined">
                                  <i className="fa fa-spinner" />
                                </span>
                                <p>Mes Projets</p>
                              </a>
                            </li>
                            <li className="sub-item">
                              <a href={"/"}>
                                <span className="material-icons-outlined">
                                  <i className="fa fa-sign-out" />
                                </span>
                                <p>Se déconnecter</p>
                              </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
                {/* EXTRA Nav */}
                {/* MAIN NAVIGATION */}
                <div className="header-nav nav-dark navbar-collapse collapse justify-content-center collapse">
                  <Navigation />
                </div>
                {/* SITE SEARCH */}
                <div id="search" className={isSearchActive ? "open" : null}>
                  <span className="close" onClick={this.handleSearchToggle} />
                  <form
                    role="search"
                    id="searchform"
                    action="/search"
                    method="get"
                    className="radius-xl"
                  >
                    <div className="input-group">
                      <input
                        defaultValue=""
                        name="q"
                        type="search"
                        placeholder="Type to search"
                      />
                      <span className="input-group-btn">
                        <button type="button" className="search-btn">
                          <i className="fa fa-search arrow-animation" />
                        </button>
                      </span>{" "}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </header>
      </>
    );
  }
}

export default Header2;
